export const appendScriptToHead = (src, callback) => {
	const script = document.createElement('script')
	script.src   = src
	script.async = true

	document.head.appendChild(script)
	script.onload = callback
}
